import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  $getRoot,
  COMMAND_PRIORITY_HIGH,
  ElementNode,
  INSERT_LINE_BREAK_COMMAND,
  KEY_ENTER_COMMAND,
  LineBreakNode,
  ParagraphNode,
} from 'lexical';
import { useEffect } from 'react';

export const SingleLinePlugin = (): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const unregisterEnter = editor.registerCommand(
      KEY_ENTER_COMMAND,
      () => true,
      COMMAND_PRIORITY_HIGH,
    );

    const unregisterLineBreak = editor.registerCommand(
      INSERT_LINE_BREAK_COMMAND,
      () => true,
      COMMAND_PRIORITY_HIGH,
    );

    const unregisterLineBreakTransform = editor.registerNodeTransform(
      LineBreakNode,
      (node) => {
        node.remove();
      },
    );

    const unregisterTransform = editor.registerNodeTransform(
      ParagraphNode,
      () => {
        const root = $getRoot();
        const children = root.getChildren();
        if (children.length <= 1) {
          return;
        }

        const first = children[0];
        if (!(first instanceof ElementNode)) {
          return;
        }

        for (let i = 1; i < children.length; i++) {
          const child = children[i];
          if (child instanceof ElementNode) {
            for (const gc of child.getChildren()) {
              first.append(gc);
            }
          }
          child.remove();
        }
      },
    );

    return () => {
      unregisterEnter();
      unregisterLineBreak();
      unregisterLineBreakTransform();
      unregisterTransform();
    };
  }, [editor]);

  return null;
};
